// slice/mediaLinkSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../axios/axios";

// Fetch media links
export const fetchMediaLinks = createAsyncThunk(
  "mediaLinks/fetch",
  async () => {
    const response = await api.get("/media-links");
    return response.data.allMediaLinks; // Extract just the array
  }
);

// Add new media link
export const addMediaLink = createAsyncThunk(
  "mediaLinks/add",
  async (newLink) => {
    const response = await api.post("/media-links", newLink);
    return response.data;
  }
);

// Update existing media link
export const updateMediaLink = createAsyncThunk(
  "mediaLinks/update",
  async ({ id, updatedMedia }) => {
    const response = await api.patch(`/media-links/${id}`, updatedMedia);
    return response.data;
  }
);

// Delete media link
export const deleteMediaLink = createAsyncThunk(
  "mediaLinks/delete",
  async (id) => {
    await api.delete(`/media-links/${id}`);
    return id;
  }
);

const mediaLinkSlice = createSlice({
  name: "mediaLinks",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMediaLinks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMediaLinks.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload; // Use the extracted array
      })
      .addCase(fetchMediaLinks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addMediaLink.fulfilled, (state, action) => {
        if (Array.isArray(state.list)) {
          state.list.push(action.payload);
        } else {
          state.list = [action.payload];
        }
      })
      .addCase(updateMediaLink.fulfilled, (state, action) => {
        const index = state.list.findIndex(
          (item) => item._id === action.payload._id
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(deleteMediaLink.fulfilled, (state, action) => {
        state.list = state.list.filter((item) => item._id !== action.payload);
      });
  },
});

export default mediaLinkSlice.reducer;
